jQuery.feature_import("js-system-alert",
    () => require("./system-alert-app"),
    mod => mod.feature_js_systemAlert
); 